export const BlankConfig = {
  id: 'empty',
  name: 'no control',
  subtitle: 'no control',
  group: 'Blank',
  formlyType: 'blank',
  formlySubtype: '',
  formlyLabel: '',
  formlyRequired: false,
  formlyDesciption: '',
  formlyOptions: [] ,
  formlyExpressionProperties: {},
  formlyValidators: {},
  formlyValidation: {}
};



// WEBPACK FOOTER //
// ./src/app/stepway/components/controls/blank/config/stepway.blank.config.js